import styles from './DigitInput.module.scss';
import cn from 'classnames';
import useDigitInput from 'react-digit-input';
import { Title3 } from "@components/new/Typo";

interface DigitInputProps {
  value?: string;
  onChange: (value: string) => void;
  hasError?: boolean;
  errorMessage?: string;
  name?: string;
  length: number;
  disabled?: boolean;
  alignFooter?: "center";
}

const DigitInput = (props: DigitInputProps) => {
  const digits = useDigitInput({
    acceptedCharacters: /^[0-9]$/,
    length: props.length,
    value: props.value ?? "",
    onChange: props.onChange,
  });

  return (
    <div
      className={cn(styles.inputContainer, {
        [styles.error]: props.hasError,
        [styles.disabled]: props.disabled,
      })}
    >
      <div className={styles.inputRow}>
        {digits.map((digit, idx) => (
          <input
            key={idx}
            className={styles.input}
            inputMode="decimal"
            autoFocus={!idx}
            {...digit}
            disabled={props.disabled}
          />
        ))}
      </div>
      {(props.hasError && props.errorMessage) ? (
        <div className={cn(styles.footer, styles[`footerAlign-${props.alignFooter}`])}>
          <Title3 color="error-sade">{props.errorMessage}</Title3>
        </div>
      ) : null}
    </div>
  );
};

export default DigitInput;
